import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import equipClassOptions from "../../../../_helpers/equipClasses";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import equipmentActions from "../../../../_actions/equipmentActions";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import ContractorSelector from "../_common/ContractorSelector";

class EditEquipmentModal extends Component {
  state = {
    formData: {
      equipmentId: 0,
      projectId: 0,
      contractorId: 0,
      selectedContractor: null,
      contractor: "",
      number: "",
      make: "",
      model: "",
      selectedClass: null,
      equipClass: "",
      description: "",
      isRental: false,
      rate: 0,
      delayFactor: 0,
      otFactor: 0,
    },
    formErrors: {
      selectedContractor: null,
      number: null,
      equipClass: null,
      make: null,
      model: null,
      description: null,
    },
  };

  componentDidMount() {
    const {
      projectId,
      equipmentDetails: selectedEquipment,
      projContractorList,
      isNew,
    } = this.props;
    if (selectedEquipment && !isNew) {
      const contractor = (projContractorList || []).find(
        (c) => c.contractorId === selectedEquipment.contractorId
      );
      const equipClass = equipClassOptions.find(
        (ec) => ec.value === selectedEquipment.equipClass
      );
      this.setState({
        formData: {
          ...this.state.formData,
          projectId,
          equipmentId: selectedEquipment.equipmentId,
          contractorId: selectedEquipment.contractorId,
          selectedContractor:
            contractor !== undefined
              ? {
                  value: contractor.contractorId,
                  label: contractor.name,
                }
              : null,
          number: selectedEquipment.number || "",
          make: selectedEquipment.make || "",
          model: selectedEquipment.model || "",
          selectedClass: equipClass !== undefined ? equipClass : null,
          equipClass: selectedEquipment.equipClass,
          description: selectedEquipment.description || "",
          isRental: selectedEquipment.isRental,
          rate: selectedEquipment.rate || 0,
          delayFactor: selectedEquipment.delayFactor || 0,
          otFactor: selectedEquipment.otFactor || 0,
        },
      });
    }
  }

  handleChange = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });

  handleChange_select = (fieldName, optionFieldName) => (selectedOption) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption.value;
    formData[optionFieldName] = selectedOption;
    this.setState({ formData }, () => this.validateForm(fieldName));
  };

  handleChange_check = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.checked },
    });

  handleBlur = (e) => this.validateForm(e.target.name);

  handleBlur_select = (fieldName) => () => this.validateForm(fieldName);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "contractorId":
        if (formData.selectedContractor === null)
          formErrors.selectedContractor = "Contractor is required";
        else formErrors.selectedContractor = null;
        break;
      case "number":
        if (!formData.number) formErrors.number = "Required";
        else formErrors.number = null;
        break;
      case "equipClass":
        if (!formData.equipClass) formErrors.equipClass = "Required";
        else formErrors.equipClass = null;
        break;
      case "make":
        if (!formData.make) formErrors.make = "Required";
        else formErrors.make = null;
        break;
      case "model":
        if (!formData.model) formErrors.model = "Required";
        else formErrors.model = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { selectedContractor, number, equipClass,make, model } = this.state.formErrors;
    const { formData } = this.state;
    return (
      selectedContractor ||
      number ||
      equipClass ||
      make ||
      model ||
      !formData.contractorId ||
      !formData.number ||
      !formData.equipClass ||
      !formData.make ||
      !formData.model
    );
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { projectId, dispatch, toggleEditEquipModal, isNew } = this.props;
    const formData = { ...this.state.formData };
    formData.projectId = projectId;
    if (!this.formIsIncomplete()) {
      if (isNew) {
        await dispatch(equipmentActions.add(formData));
      } else {
        await dispatch(equipmentActions.update(formData));
      }
      toggleEditEquipModal();
    }
  };

  toggleAlert_errorOnSubmit = () => {
    this.setState({
      showAlert_errorOnSubmit: !this.state.showAlert_errorOnSubmit,
    });
  };

  handleAlert_errorOnSubmit = () => (e) => {
    e && e.preventDefault();
    this.toggleAlert_errorOnSubmit();
  };

  render() {
    const { formData, formErrors } = this.state;
    const {
      showEditEquipModal,
      toggleEditEquipModal,
      projectId,
      projContractorList,
      isNew,
    } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditEquipModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditEquipModal}
          toggle={toggleEditEquipModal}
          className={this.props.className}
          size={"lg"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditEquipModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon={isNew ? "plus" : "edit"} className="fa-fw mr-2" />
            {isNew ? "Add New Equipment" : "Edit Equipment"}
          </ModalHeader>
          <ModalBody>
            <form id="editEquipForm" onSubmit={this.handleSubmit} autoComplete={"off"}>
              <ContractorSelector
                projectId={projectId}
                contractorId={formData.contractorId}
                setContractorId={(contractorId) =>
                  this.setState({ formData: { ...this.state.formData, contractorId } })
                }
              />
              {/* <div className="card mx-2 mt-2 bg-lightgray">
                <div className="card-body">
                  <div className="form-row form-group mb-0">
                    <label className="col-sm-3 col-form-label" htmlFor="contractorId">
                      <b>Contractor:</b>*
                    </label>
                    <div className="col-sm-6 my-auto">
                      <Select
                        name="contractorId"
                        id="contractorId"
                        value={formData.selectedContractor}
                        options={
                          projContractorList &&
                          getProjContractorOptions(projContractorList)
                        }
                        onChange={this.handleChange_select(
                          "contractorId",
                          "selectedContractor"
                        )}
                        placeholder="(Select a Contractor)"
                        onBlur={this.handleBlur_select("contractorId")}
                      />
                      {formErrors.selectedContractor && (
                        <span className="error-small">
                          <small>{formErrors.selectedContractor}</small>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="card m-2">
                <div className="card-body">
                  <div className="form-row form-group mb-3">
                    <label htmlFor="number" className="col-sm-3 col-form-label">
                      <b>Number:</b>*
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="number"
                        id="number"
                        className="form-control"
                        maxLength="20"
                        value={formData.number}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                      <span className="my-0 py-0 mr-2">
                        <small>If more than one, separate by comma.</small>
                      </span>
                      {formErrors.number && (
                        <span className="error-small">
                          <small>{formErrors.number}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="equipClass" className="col-sm-3 col-form-label">
                      <b>Class:</b>*
                    </label>
                    <div className="col-sm-9">
                      <Select
                        name="equipClass"
                        id="equipClass"
                        value={formData.selectedClass}
                        options={equipClassOptions}
                        onChange={this.handleChange_select("equipClass", "selectedClass")}
                        onBlur={this.handleBlur_select("equipClass")}
                        isDisabled={!formData.contractorId}
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                      />
                      {formErrors.equipClass && (
                        <span className="error-small">
                          <small>{formErrors.equipClass}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="make" className="col-sm-3 col-form-label">
                      <b>Make:</b>*
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="make"
                        id="make"
                        className="form-control"
                        maxLength="50"
                        value={formData.make}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                      {formErrors.make && (
                        <span className="error-small">
                          <small>{formErrors.make}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="model" className="col-sm-3 col-form-label">
                      <b>Model:</b>*
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="model"
                        id="model"
                        className="form-control"
                        value={formData.model}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                      {formErrors.model && (
                        <span className="error-small">
                          <small>{formErrors.model}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="description" className="col-sm-3 col-form-label">
                      Description:
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="description"
                        id="description"
                        className="form-control"
                        value={formData.description}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-9">
                      <div className="custom-control-inline custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          name="isRental"
                          id="isRental"
                          className="custom-control-input my-auto ml-2"
                          disabled={!formData.contractorId}
                          value={formData.isRental}
                          checked={formData.isRental}
                          onChange={this.handleChange_check}
                        />
                        <label
                          htmlFor="isRental"
                          className="custom-control-label my-auto"
                        >
                          This is a rental equipment
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="rate" className="col-sm-3 col-form-label">
                      Rate:
                    </label>
                    <div className="col-sm-4 mr-1">
                      <input
                        type="number"
                        name="rate"
                        id="rate"
                        className="form-control"
                        value={formData.rate}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="delayFactor" className="col-sm-3 col-form-label">
                      Delay Factor:
                    </label>
                    <div className="col-sm-4 mr-1">
                      <input
                        type="number"
                        name="delayFactor"
                        id="delayFactor"
                        className="form-control"
                        value={formData.delayFactor}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="otFactor" className="col-sm-3 col-form-label">
                      OT Factor:
                    </label>
                    <div className="col-sm-4 mr-1">
                      <input
                        type="number"
                        name="otFactor"
                        id="otFactor"
                        className="form-control"
                        value={formData.otFactor}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={!formData.contractorId}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="ml-2">
                <small>* indicates required fields</small>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <input
                className="btn btn-primary"
                name="editEquipButton"
                type="submit"
                form="editEquipForm"
                onClick={this.handleSubmit}
                value={isNew ? "Add" : "Save"}
                disabled={this.formIsIncomplete()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditEquipModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  equipmentDetails: state.equipment.openEquipmentDetails[ownProps.projectId]
    ? state.equipment.openEquipmentDetails[ownProps.projectId][ownProps.equipmentId] ||
      null
    : null,
});

export default connect(mapStateToProps)(EditEquipmentModal);
